export const ACTUALITY_SET_STATUS = 'ACTUALITY_SET_STATUS'
export const NOTIFICATIONS_FETCHED = 'NOTIFICATIONS_FETCHED'
export const SET_USER_IS_CHEER = 'SET_USER_IS_CHEER'
export const SET_CHEER_ENTITY = 'SET_CHEER_ENTITY'

function notificationsFetched(state, notifications, meta, reset) {
    let data = reset ? {} : { ...state.notifications.data }

    notifications.forEach(item => {
        data[item.id] = item
    })

    return {
        ...state,
        notifications: {
            ...state.notifications,
            data,
            cursor: meta.cursor.next,
        },
    }
}

function toggleLoginModal(state) {
    return {
        ...state,
        login: {
            ...state.login,
            modalVisible: !state.login.modalVisible,
        },
    }
}

function toggleCheerModal(state) {
    return {
        ...state,
        cheer: {
            ...state.cheer,
            modalVisible: !state.cheer.modalVisible,
        },
    }
}

function toggleForceLoginPage(state) {
    return {
        ...state,
        login: {
            ...state.login,
            forceLoginPage: !state.login.forceLoginPage,
            modalVisible: false,
        },
    }
}

function setLoginModal(state, text, successAction) {
    return {
        ...state,
        login: {
            ...state.login,
            modalVisible: true,
            modalText: text,
            successAction,
        },
    }
}

function setCheerModal(state, entity, text, successAction, fromGroup) {
    return {
        ...state,
        cheer: {
            ...state.cheer,
            modalVisible: true,
            modalText: text,
            organisingEntity: entity,
            successAction,
            fromGroup,
        },
    }
}

function setCheerEntity(state, entity) {
    return {
        ...state,
        cheer: {
            ...state.cheer,
            entity: entity,
        },
    }
}

function toggleLogin(state, force) {
    return {
        ...state,
        login: {
            ...state.login,
            modalVisible: false,
            show: typeof force !== 'undefined' ? force : !state.login.show,
        },
    }
}

function toggleBusyCheer(state) {
    return {
        ...state,
        cheer: {
            ...state.cheer,
            busy: !state.cheer.busy,
        },
    }
}

function toggleFetchingLogout(state) {
    return {
        ...state,
        login: {
            ...state.login,
            fetchingLogout: !state.login.fetchingLogout,
        },
    }
}

function toggleAuthModalOpen(state, force) {
    return {
        ...state,
        login: {
            ...state.login,
            authModalOpen: typeof force !== 'undefined' ? force : (!state.login.authModalOpen),
        },
    }
}

function setLoginAction(state, loginAction) {
    return {
        ...state,
        login: {
            ...state.login,
            loginAction,
        },
    }
}

function setRegisterPostMsg(state, data) {
    return {
        ...state,
        register: {
            ...state.register,
            postMsg: data,
        },
    }
}

function setBusyAttendance(state, busy) {
    return {
        ...state,
        attendance: {
            ...state.attendance,
            busy,
        },
    }
}

function setBusyInvitation(state, busy) {
    return {
        ...state,
        invitation: {
            ...state.invitation,
            busy,
        },
    }
}

function setUserIsCheer(state, userIsCheer) {
    return {
        ...state,
        cheer: {
            ...state.cheer,
            isCheer: userIsCheer,
        },
    }
}

function toggleAttendanceChanged(state) {
    return {
        ...state,
        attendance: {
            ...state.attendance,
            isChanged: !state.attendance.isChanged,
        },
    }
}

function setNotificationsActive(state, action) {
    return ({
        ...state,
        notifications: {
            ...state.notifications,
            active: action.active,
        },
    })
}

function eventsFetched(state, events, meta, reset) {
    let ids = reset ? [] : [...state.events.ids]
    let data = reset ? {} : { ...state.events.data }

    events.forEach(item => {
        ids.push(item.id)
        data[item.id] = item
    })

    return {
        ...state,
        events: {
            ...state.events,
            ids: [...new Set(ids)],
            data,
            cursor: meta.cursor.next,
            fetched: true,
        },
    }
}

function newsFetched(state, news, reset) {
    let ids = reset ? [] : [...state.news.ids]
    let data = reset ? {} : { ...state.news.data }

    news.forEach(item => {
        ids.push(item.id)
        data[item.id] = item
    })

    return {
        ...state,
        news: {
            ...state.news,
            ids: [...new Set(ids)],
            data,
        },
    }
}

function notFilteredNewsFetched(state, notFilteredNews, reset) {
    let ids = reset ? [] : [...state.notFilteredNews.ids]
    let data = reset ? {} : { ...state.notFilteredNews.data }

    notFilteredNews.forEach(item => {
        ids.push(item.id)
        data[item.id] = item
    })

    return {
        ...state,
        notFilteredNews: {
            ...state.notFilteredNews,
            ids: [...new Set(ids)],
            data,
        },
    }
}

function newsCategoriesFetched(state, categories) {
    return {
        ...state,
        newsCategories: categories,
    }
}


/**
 * Fetch available news tags
 *
 * @param {Object} state
 * @param {Object} tags
 * @return {Object}
 */
function newsTagsFetched(state, tags) {
    return {
        ...state,
        newsTags: tags,
    }
}

function slidesFetched(state, slides, reset) {
    let ids = reset ? [] : [...state.slides.ids]
    let data = reset ? {} : { ...state.slides.data }

    slides.forEach(item => {
        ids.push(item.id)
        data[item.id] = item
    })

    return {
        ...state,
        slides: {
            ...state.slides,
            ids: [...new Set(ids)],
            data,
        },
    }
}

function actualityFetched(state, fullActuality) {
    return {
        ...state,
        news: {
            ...state.news,
            fullActuality: fullActuality,
        },
    }
}

function setCursor(state, entity, value) {
    return {
        ...state,
        [entity]: {
            ...state[entity],
            cursor: state[entity].cursor === null ? null : (typeof value === 'object' && value !== null ? (state[entity].cursor + value.add) : value),
        },
    }
}

function setSuperAdminSystem(state, system) {
    return {
        ...state,
        superAdmin: {
            ...state.superAdmin,
            system: system,
        },
    }
}

function setActualityId(state, actualityId) {
    return {
        ...state,
        news: {
            ...state.news,
            actualityId,
        },
    }
}

function entitiesFetched(state, events, groups, sportVenues) {
    return {
        ...state,
        entities: {
            ...state.entities,
            events: events,
            groups: groups,
            sportVenues: sportVenues,
        },
    }
}

/**
 * Fetch users to entities
 *
 * @param {Object} state
 * @param {Object} users
 * @return {*}
 */
function entitiesFetchedUsers(state, users) {
    return {
        ...state,
        entities: {
            ...state.entities,
            users: users,
        },
    }
}

function setMapLoaded(state, loading) {
    return {
        ...state,
        loadingMap: loading,
    }
}

function toggleMenuResponsive(state, force) {
    return {
        ...state,
        menu: {
            ...state.menu,
            isResponsive: typeof force !== 'undefined' ? force : !state.menu.isResponsive,
        },
    }
}

/**
 * Set description length size
 *
 * @param {Object} state
 * @param {integer} descriptionHeightSize
 * @return {Object}
 */
function setDescriptionHeightSize(state, descriptionHeightSize) {
    return {
        ...state,
        descriptionHeightSize: descriptionHeightSize,
    }
}

/**
 * List of recommended groups to cheer in modal when cheering subgroup
 *
 * @param {Object} state
 * @param {Object[]} groups
 * @return {Object}
 */
function setGroupsRecommendedToCheer(state, groups) {
    return {
        ...state,
        recommendedGroups: groups,
    }
}

/**
 * Toggle cheering status in modal when cheering subgroup
 *
 * @param {Object} state
 * @param {Object} id
 * @return {Object}
 */
function toggleCheeringRecommendedGroup(state, id) {
    const recommendedGroups = [...state.recommendedGroups]
    const groupIndex = recommendedGroups.findIndex(group => group.id === id)

    const userIsCheer = recommendedGroups[groupIndex].additionalInfo.data.userStatus.isCheering
    recommendedGroups[groupIndex].additionalInfo.data.userStatus.isCheering = !userIsCheer

    return {
        ...state,
        recommendedGroups,
    }
}

/**
 * Set success login action into store
 *
 * @param {Object} state
 * @param {Function} successAction
 * @return {{login: {successAction: *}}}
 */
function setSuccessLoginAction(state, successAction) {
    return {
        ...state,
        login: {
            ...state.login,
            successAction: successAction,
        },
    }
}

function setAttendanceData(state, data) {
    return {
        ...state,
        attendance: {
            ...state.attendance,
            data: data,
        },
    }
}

function setInvitationData(state, data) {
    return {
        ...state,
        invitation: {
            ...state.invitation,
            data: data,
        },
    }
}

/**
 * Set roster positions into store
 *
 * @param {Object} state
 * @param {array} positions
 * @return {{roster: {positions: *}}}
 */
function setRosterPositions(state, positions) {
    return {
        ...state,
        roster: {
            ...state.roster,
            positions,
        },
    }
}

/**
 * Set notifications popup lock
 *
 * @param {Object} state
 * @param {Object} action
 * @return {{notifications: {lockPopup: *}}}
 */
function setNotificationLockPopup(state, action) {
    return {
        ...state,
        notifications: {
            ...state.notifications,
            lockPopup: action,
        },
    }
}

/**
 * Set actuality status
 *
 * @param {Object} state
 * @param {int|null} status
 * @return {{status: *}}
 */
function actualitySetStatus(state, status) {
    return {
        ...state,
        news: {
            ...state.news,
            status: status,
        },
    }
}

/**
 * Set selected filter for news by category
 *
 * @param {Object} state
 * @param {string} filter
 * @return {{news: {filter}}
 */
function setNewsFilter(state, filter) {
    return {
        ...state,
        news: {
            ...state.news,
            filter: filter,
        },
    }
}
/**
 * Set title for list of news by tag
 *
 * @param {Object} state
 * @param {string} title
 * @return {{newsListTitle: {title}}
 */
function newsListTitle(state, title) {
    return {
        ...state,
        newsListTitle: title,
    }
}

export default function(state = [], action) {
    switch (action.type) {
        case NOTIFICATIONS_FETCHED:
            return notificationsFetched(
                state,
                action.notifications,
                action.meta,
                action.reset
            )
        case 'NOTIFICATIONS_ACTIVE':
            return setNotificationsActive(state, action)
        case 'NOTIFICATIONS_LOCK_POPUP':
            return setNotificationLockPopup(state, action.lockPopup)
        case 'TOGGLE_LOGIN_MODAL':
            return toggleLoginModal(state)
        case 'TOGGLE_CHEER_MODAL':
            return toggleCheerModal(state)
        case 'SET_LOGIN_MODAL':
            return setLoginModal(state, action.text, action.successAction)
        case 'SET_CHEER_MODAL':
            return setCheerModal(
                state,
                action.organisingEntity,
                action.text,
                action.successAction,
                action.fromGroup || false
            )
        case SET_CHEER_ENTITY:
            return setCheerEntity(state, action.entity)
        case 'TOGGLE_FORCE_LOGIN_PAGE':
            return toggleForceLoginPage(state)
        case 'TOGGLE_LOGIN':
            return toggleLogin(state, action.force)
        case 'TOGGLE_BUSY_CHEER':
            return toggleBusyCheer(state)
        case 'TOGGLE_FETCHING_LOGOUT':
            return toggleFetchingLogout(state)
        case 'TOGGLE_AUTH_MODAL_OPEN':
            return toggleAuthModalOpen(state, action.force)
        case SET_USER_IS_CHEER:
            return setUserIsCheer(state, action.userIsCheer)
        case 'SET_LOGIN_ACTION':
            return setLoginAction(state, action.loginAction)
        case 'SET_REGISTER_POST_MSG':
            return setRegisterPostMsg(state, action.data)
        case 'SET_BUSY_ATTENDANCE':
            return setBusyAttendance(state, action.busy)
        case 'SET_ATTENDANCE_DATA':
            return setAttendanceData(state, action.data)
        case 'SET_BUSY_INVITATION':
            return setBusyInvitation(state, action.busy)
        case 'SET_INVITATION_DATA':
            return setInvitationData(state, action.data)
        case 'SET_ROSTER_POSITIONS':
            return setRosterPositions(state, action.positions)
        case 'TOGGLE_ATTENDANCE_CHANGED':
            return toggleAttendanceChanged(state)
        case 'EVENTS_FETCHED':
            return eventsFetched(
                state,
                action.events,
                action.meta,
                action.reset
            )
        case 'NEWS_FETCHED':
            return newsFetched(state, action.news, action.reset)
        case 'NEWS_CATEGORIES_FETCHED':
            return newsCategoriesFetched(state, action.newsCategories)
        case 'SLIDES_FETCHED':
            return slidesFetched(state, action.slides, action.reset)
        case 'ACTUALITY_FETCHED':
            return actualityFetched(state, action.fullActuality)
        case ACTUALITY_SET_STATUS:
            return actualitySetStatus(state, action.status)
        case 'SET_CURSOR':
            return setCursor(state, action.entity, action.value)
        case 'SET_SUPER_ADMIN_SYSTEM':
            return setSuperAdminSystem(state, action.system)
        case 'SET_ACTUALITY_ID':
            return setActualityId(state, action.value)
        case 'ENTITIES_FETCHED':
            return entitiesFetched(
                state,
                action.events,
                action.groups,
                action.sportVenues
            )
        case 'ENTITIES_FETCHED_USERS':
            return entitiesFetchedUsers(state, action.users)
        case 'SET_MAP_LOADED':
            return setMapLoaded(state, action.loading)
        case 'TOGGLE_MENU_RESPONSIVE':
            return toggleMenuResponsive(state, action.force)
        case 'SET_DESCRIPTION_HEIGHT_SIZE':
            return setDescriptionHeightSize(
                state,
                action.descriptionHeightSize
            )
        case 'SET_GROUPS_RECOMMENDED_TO_CHEER':
            return setGroupsRecommendedToCheer(state, action.groups)
        case 'TOGGLE_CHEERING_RECOMMENDED_GROUP':
            return toggleCheeringRecommendedGroup(state, action.id)
        case 'SET_SUCCESS_LOGIN_ACTION':
            return setSuccessLoginAction(state, action.successAction)
        case 'SET_NEWS_FILTER':
            return setNewsFilter(state, action.filter)
        case 'NOT_FILTERED_NEWS_FETCHED':
            return notFilteredNewsFetched(
                state,
                action.notFilteredNews,
                action.reset
            )
        case 'NEWS_TAGS_FETCHED':
            return newsTagsFetched(state, action.newsTags)
        case 'NEWS_LIST_TITLE':
            return newsListTitle(state, action.newsListTitle)
        default:
            return state
    }
}
